import { usePage } from "@inertiajs/react";
import { CreditCardIcon } from "@heroicons/react/24/outline";
import { Button } from "@components/ui/button";
import { useCompleteDeployTask } from "@api/deploys.hooks";
import { DeployPanel } from "@components/deploy/DeployPanel";

export default function PaymentRequiredScreen({ actions }: { actions?: React.ReactNode }) {
  const { deploy, ads_account } = usePage<{
    deploy?: { id: number };
    ads_account?: { platform_settings?: { google?: { customer_id?: string } } };
  }>().props;

  const completeTask = useCompleteDeployTask(deploy?.id);

  const customerId = ads_account?.platform_settings?.google?.customer_id?.replace(/-/g, "");
  const billingUrl = customerId
    ? `https://ads.google.com/aw/billing/paymentmethods?ocid=${customerId}`
    : "https://ads.google.com/aw/billing/paymentmethods";

  return (
    <DeployPanel.Root>
      {actions && (
        <DeployPanel.Header>
          <div />
          <DeployPanel.Actions>{actions}</DeployPanel.Actions>
        </DeployPanel.Header>
      )}
      <DeployPanel.Body centered className="p-12">
        <div className="max-w-md w-full text-center">
          <span className="inline-block text-xs font-medium text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-3 py-1 mb-4">
            External action needed
          </span>

          <div className="mx-auto w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mb-4">
            <CreditCardIcon className="size-7 text-amber-600" />
          </div>

          <h2 className="text-xl font-semibold text-base-600">Add Payment Method</h2>
          <p className="text-sm text-base-500 mt-2">
            Google requires a valid payment method to run your ads campaign. Please add a payment
            method in Google Ads, then come back here.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6">
            <Button variant="outline" onClick={() => window.open(billingUrl, "_blank")}>
              Add Payment Method
            </Button>
            <Button onClick={() => completeTask.mutate("CheckingBilling")}>
              Payment Method Added
            </Button>
          </div>
        </div>
      </DeployPanel.Body>
    </DeployPanel.Root>
  );
}
